import { QueryEncoder } from '@angular/http';

export class CustomQueryEncoderHelper extends QueryEncoder {
  encodeKey(k: string): string {
    k = super.encodeKey(k);
    return encodeURIComponent(k);
  }
  encodeValue(v: string): string {
    v = super.encodeValue(v);
    return encodeURIComponent(v);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/helpers/custom-query-encode-helper.ts